(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[29],{

/***/ "5siB":
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),

/***/ "ZFcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Slider; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-5 mt-10',
    thControl: 'mx-5'
  },
  center: {
    thInner: 'relative',
    thControls: 'z-2 absolute flex justify-between pointer-events-none top-1/2 transform -translate-y-1/2 w-full',
    thControl: 'pointer-events-auto before:absolute before:content-[""] before:h-[120px] before:right-0 before:h-[40px]',
    thControlLeft: 'transform -translate-x-1/2',
    thControlRight: 'transform translate-x-1/2',
    thControlDisabled: 'invisible'
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-5',
    thControl: 'mx-5'
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-5 mb-10 order-first',
    thControl: 'mx-5'
  }
};
var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND
    });
  },
  brand: function brand(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].SAFFRON
    });
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.jsx









var __jsx = react_default.a.createElement;







if ( true && typeof document !== 'undefined' && // $FlowFixMe
!('scrollBehavior' in document.documentElement.style)) {
  // $FlowFixMe
  __webpack_require__("5siB").polyfill();
}

function Slider(props) {
  var className = props.className,
      children = props.children,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      hasControls = props.hasControls,
      hasTabindex = props.hasTabindex,
      id = props.id,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$navPosition = props.navPosition,
      navPosition = _props$navPosition === void 0 ? 'top' : _props$navPosition,
      _props$nbItemsToScrol = props.nbItemsToScroll,
      nbItemsToScroll = _props$nbItemsToScrol === void 0 ? 1 : _props$nbItemsToScrol,
      nextLabel = props.nextLabel,
      onChangeIndex = props.onChangeIndex,
      onNext = props.onNext,
      onPrevious = props.onPrevious,
      previousLabel = props.previousLabel,
      scrollAreaClassName = props.scrollAreaClassName,
      scrollAreaContainerClassName = props.scrollAreaContainerClassName,
      scrollControlsClassName = props.scrollControlsClassName,
      scrollItemClassName = props.scrollItemClassName,
      scrollItemStyle = props.scrollItemStyle,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var childrenCount = react["Children"].count(children);
  var containerRef = Object(react["useRef"])(null);
  var refsArray = Object(react["useRef"])([]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useState = Object(react["useState"])(initialIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])({
    hasReachedLeft: false,
    hasReachedRight: false
  }),
      reachedX = _useState2[0],
      setReachedX = _useState2[1];

  var _useState3 = Object(react["useState"])(react["Children"].map(children, function () {
    return false;
  })),
      hiddenIndexes = _useState3[0],
      setHiddenIndexes = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      prevInitialIndex = _useState4[0],
      setPrevInitialIndex = _useState4[1];

  Object(react["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  var getHiddenIndexes = function getHiddenIndexes() {
    if (cols > 0) {
      return;
    }

    if (containerRef.current) {
      var _containerRef$current = containerRef.current,
          clientWidth = _containerRef$current.clientWidth,
          scrollLeft = _containerRef$current.scrollLeft,
          containerOffsetLeft = _containerRef$current.offsetLeft;
      var indexes = refsArray.current.filter(Boolean).map(function (_ref) {
        var offsetLeft = _ref.offsetLeft,
            offsetWidth = _ref.offsetWidth;
        return offsetLeft < scrollLeft + containerOffsetLeft || offsetLeft + offsetWidth > scrollLeft + containerOffsetLeft + clientWidth;
      });
      setHiddenIndexes(indexes);
    }
  };

  var getReachedX = function getReachedX() {
    if (containerRef.current) {
      var _containerRef$current2 = containerRef.current,
          clientWidth = _containerRef$current2.clientWidth,
          scrollLeft = _containerRef$current2.scrollLeft,
          scrollWidth = _containerRef$current2.scrollWidth;

      var _hasReachedLeft = scrollLeft === 0;

      var _hasReachedRight = scrollLeft + clientWidth >= scrollWidth;

      setReachedX({
        hasReachedLeft: _hasReachedLeft,
        hasReachedRight: _hasReachedRight
      });
    }
  }; // get index in possible range


  var getSafeIndex = function getSafeIndex(idx) {
    if (idx < 0) {
      return 0;
    }

    var maxIndex = cols > 0 ? childrenCount - cols : childrenCount - 1;
    return idx > maxIndex ? maxIndex : idx;
  };

  var scrollToIndex = function scrollToIndex(index, e) {
    var _containerRef$current3;

    if (e) {
      e.preventDefault();
    }

    var idx = getSafeIndex(index);
    var scrollValue = refsArray.current.slice(0, idx).reduce(function (v, ref) {
      // $FlowFixMe
      return v + ref.offsetWidth;
    }, 0);

    if ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollTo) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollValue
      });
    }
  };

  Object(react["useEffect"])(function () {
    getReachedX();
    getHiddenIndexes();
    scrollToIndex(initialIndex);
    setPrevInitialIndex(initialIndex);
  }, [children]);
  Object(react["useEffect"])(function () {
    if (initialIndex !== prevInitialIndex) {
      scrollToIndex(initialIndex);
      setPrevInitialIndex(initialIndex);
    }
  }, [initialIndex]);

  if (!childrenCount) {
    return null;
  }

  var onScroll = throttle_default()(function () {
    getReachedX();
    getHiddenIndexes(); // $FlowFixMe

    var _containerRef$current4 = containerRef.current,
        offsetLeft = _containerRef$current4.offsetLeft,
        scrollLeft = _containerRef$current4.scrollLeft;
    var positions = refsArray.current.filter(Boolean).map(function (ref) {
      return ref.offsetLeft;
    });
    var closest = positions.reduce(function (prev, curr) {
      return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
    }, offsetLeft);
    var pos = positions.indexOf(closest);

    if (activeIndex > pos) {
      onPrevious && onPrevious();
    } else if (activeIndex < pos) {
      onNext && onNext();
    }

    if (pos > -1) {
      setActiveIndex(pos);
      var el = refsArray.current[pos]; // $FlowFixMe

      var elFocused = hasTabindex ? el : el.firstChild; // $FlowFixMe

      elFocused.focus({
        preventScroll: true
      });
    }
  }, 250);

  var _themes$theme = themes[theme]({
    navPosition: navPosition
  }),
      thControl = _themes$theme.thControl,
      thControlLeft = _themes$theme.thControlLeft,
      thControlRight = _themes$theme.thControlRight,
      thControlColor = _themes$theme.thControlColor,
      thControlDisabled = _themes$theme.thControlDisabled,
      thControls = _themes$theme.thControls,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasReachedLeft = reachedX.hasReachedLeft,
      hasReachedRight = reachedX.hasReachedRight;
  var isSnapScrollDisabled = isRTL && Object(feature_testing["a" /* hasTouch */])();
  return __jsx("div", {
    className: classnames_default()(className, thRoot, 'relative', {
      'transform -scale-x-1': isRTL
    }),
    dir: "ltr",
    id: id
  }, __jsx("div", {
    className: classnames_default()('h-full', thInner)
  }, __jsx("div", {
    className: scrollAreaClassName
  }, __jsx("div", {
    className: classnames_default()('flex flex-row flex-nowrap w-full', scrollAreaContainerClassName),
    onScroll: onScroll,
    ref: containerRef
  }, react["Children"].map(children, function (child, idx) {
    var _classnames;

    var isHidden = cols > 0 ? idx < activeIndex || idx >= activeIndex + cols : hiddenIndexes[idx];
    return __jsx("div", Object(esm_extends["a" /* default */])({
      "aria-hidden": isHidden,
      className: classnames_default()(isFunction_default()(scrollItemClassName) ? scrollItemClassName(idx) : scrollItemClassName, (_classnames = {
        'snap-start': !isSnapScrollDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "w-1/".concat(cols), cols > 1), Object(defineProperty["a" /* default */])(_classnames, 'w-full', cols === 1), Object(defineProperty["a" /* default */])(_classnames, 'transform -scale-x-1', isRTL), _classnames)),
      key: idx,
      ref: function ref(_ref2) {
        refsArray.current[idx] = _ref2;
      }
    }, hasTabindex ? {
      tabIndex: -1
    } : null, {
      style: scrollItemStyle
    }), /*#__PURE__*/Object(react["cloneElement"])(child, {
      dir: isRTL ? 'rtl' : 'ltr'
    }));
  })))), hasControls && !(hasReachedLeft && hasReachedRight) && __jsx("div", {
    className: classnames_default()(scrollControlsClassName, thControls)
  }, __jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedLeft)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedLeft,
    label: previousLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex - nbItemsToScroll, e);
    }
  }), __jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedRight)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedRight,
    label: nextLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex + nbItemsToScroll, e);
    },
    rotation: 180
  })));
}

/***/ })

}]);